import React from 'react';
import { OptimizedImage } from '../common';
import { ChevronRight, Sparkles, Zap, Target } from 'lucide-react';


export const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: Sparkles,
      title: 'AI Solutions Designed for Everyone, No Matter Your Expertise',
      description: 'Experience AI that adapts to your unique needs and enhances your daily tasks.',
      action: 'Learn More',
      image: '/images/003.designed.jpeg',
    },
    {
      icon: Zap,
      title: 'Accessible AI Tools for Everyday Use',
      description: 'Our AI tools are designed for seamless integration into your life, making you more productive in your daily life.',
      action: 'Learn More',
      image: '/images/004.empower.jpeg',
    },
    {
      icon: Target,
      title: 'Making Complex tasks simple with AI',
      description: 'We deliver practical AI solutions that yield real-world results for everyone.',
      action: 'Learn More',
      image: '/images/005.complex.jpeg',
    },
  ];

  return (
    <section className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-[#FAF6F0]">
      <div className="container mx-auto">
        <div
          className="mx-auto mb-12 w-full max-w-3xl text-center md:mb-18 lg:mb-20"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold font-gabarito text-Color-Neutral-Darkest leading-tight">
            Artificial Intelligence Tailored for You
          </h2>
        </div>
        <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          {features.map((feature, index) => {
            return (
              <div
                key={index}
                className="flex w-full flex-col items-center text-center"
              >
                <div className="mb-6 md:mb-8 w-full aspect-[4/3] rounded-2xl overflow-hidden">
                  <OptimizedImage
                    src={feature.image} 
                    alt={feature.title} 
                    className="rounded-2xl"
                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  />
                </div>
                <h3 className="mb-3 text-xl sm:text-2xl md:text-3xl font-bold font-gabarito text-Color-Neutral-Darkest md:mb-4 leading-tight">
                  {feature.title}
                </h3>
                <p className="text-Color-Neutral-Dark font-cairo mb-6">
                  {feature.description}
                </p>
                <button className="flex items-center gap-2 text-Color-Neutral-Darkest hover:text-[#C97B5A] transition-colors font-cairo font-medium">
                  {feature.action}
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};